
import Noresult from "@/components/Noresult";
import Scroller from "@/components/Scroller";
import List from "@/components/Hall/TenderingList";
import api from "../../api";
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
components: { Noresult, Scroller, List, XButton, XInput },
mounted() {
this.getList();
},
data: () => ({
status: {
upStatus: "default",
downStatus: "default",
pullupText: "",
},
datas: [],
nextPage: 1,
title:""
}),
methods: {
getList() {
api.vega.tender
.tenderList({
page: 1,
size: 20,
title: this.title
})
.then((res) => {
const code = res.data;
if (code.code === 0 && code.sub_code === 0) {
const data = res.data.data;
this.datas = data.list;
if (data.count < 20) {
this.$nextTick(() => {
this.$refs.scroller.disablePullup();
});
this.status.pullupText = "没有更多了";
} else {
this.nextPage = 2;
this.status.pullupText = "上拉加载更多";
}
}
});
},
pullUp() {
this.status.pullupText = "加载中...";
api.vega.tender
.tenderList({
page: this.nextPage,
size: 20,
})
.then((res) => {
const code = res.data;
if (code.code === 0 && code.sub_code === 0) {
const data = res.data.data;
if (data.list && data.list.length !== 0) {
this.datas = [...this.datas, ...data.list];
this.nextPage++;
this.$refs.scroller.donePullup();
this.status.pullupText = "上拉加载更多";
} else {
this.$nextTick(() => {
this.$refs.scroller.disablePullup();
this.$refs.scroller.donePullup();
});
this.status.pullupText = "没有更多了";
}
}
});
},
toDetail(item) {
this.$router.push({
path: "/hall/detail",
query: {
id: item.id,
},
});
},
},
};
